import React, {useState} from 'react';
import {View} from 'react-native';

import Checkbox from '/component/base/Checkbox/Checkbox';
import Text from '/component/base/Text';
import TextInput from '/component/base/TextInput';
import {DownlineProfile} from '/constant/TestIDs';
import testProperties from '/util/testing/testProperties';

import {styles} from './ProfileNotesSectionWithCheckbox.style';

export const ProfileNotesSectionWithCheckbox = ({
  notes = '',
  phoneNumber = '',
  clientDetails = {},
  onValueChange,
  setUpdatedNotes,
  setClientId,
  isDisabled = false,
  appendPhoneNumber = false,
  notesCheckboxValue = true,
}: any) => {
  const {
    id, //clientId need to send when we click on Merge profile
  } = clientDetails || {};
  const [isChecked, setIsChecked] = useState(true);

  const additionalText = `Phone: ${phoneNumber}`;
  const notesText = `${notes}\n\n\n`;
  const phoneNumberOfCandidate = `${notes ? notesText : ''}${additionalText}`;
  if (notesCheckboxValue === true) {
    setUpdatedNotes(phoneNumberOfCandidate);
    setClientId(id);
  }
  const getDisabledIconStyle = (isChecked: any) => {
    return isChecked ? styles.selectedIcon : styles.unSelectedIcon;
  };

  const getSocialUrlStyleProp = (isChecked: any) => {
    return isChecked
      ? {...styles.disabledContainer, ...styles.taskItemContainer}
      : {...styles.taskItemContainer, ...styles.enabledContainer};
  };

  const getTaskItemIcon = (isChecked: any) => {
    return isChecked ? 'checkbox-selected' : 'checkbox-unselected';
  };

  const toggleCheckbox = () => {
    const newstate = !isChecked;
    setIsChecked(newstate);
    onValueChange(newstate); // Pass the new value to the parent
    newstate && appendPhoneNumber
      ? setUpdatedNotes(phoneNumberOfCandidate)
      : newstate
      ? setUpdatedNotes(notes)
      : setUpdatedNotes(' ');
    setClientId(id);
  };

  return (
    <>
      <View
        style={styles.flexDirection}
        {...testProperties(DownlineProfile.profileNotesSection)}>
        <View style={styles.iconContainer}>
          <Checkbox
            checkedIconName={getTaskItemIcon(isChecked)}
            checked={isChecked}
            style={{icon: getDisabledIconStyle(isChecked)}}
            onChange={toggleCheckbox}
            rectangleCheckbox
          />
        </View>
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          style={styles.header}
          {...testProperties(DownlineProfile.profileNotesSectionNotesLabel)}>
          {' '}
          Notes{' '}
        </Text>
      </View>
      <View style={styles.noteField} {...testProperties(null, true)}>
        <View style={getSocialUrlStyleProp(isChecked)}>
          <TextInput
            value={appendPhoneNumber ? phoneNumberOfCandidate : notes}
            disabled={isDisabled}
            multiline={true}
            numberOfLines={3}
            {...testProperties(DownlineProfile.profileNotesSectionNotesInput)}
          />
        </View>
      </View>
      {isChecked && (
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          style={styles.footerText}
          {...testProperties(DownlineProfile.profileNotesSectionFooterLabel)}>
          Candidate profile notes will be combined any other existing Client
          profile notes
        </Text>
      )}
    </>
  );
};

export default ProfileNotesSectionWithCheckbox;
